import React from "react";

const EditIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 14 14" fill="none">
    <path
      d="M1.75 12.25H12.25V5.25H13.5V12.25C13.5 12.9404 12.9404 13.5 12.25 13.5H1.75C1.05964 13.5 0.5 12.9404 0.5 12.25V1.75C0.5 1.05964 1.05964 0.5 1.75 0.5H8.75V1.75H1.75V12.25Z"
      fill="currentColor"
    />
    <path
      d="M13.1464 1.35355C13.3417 1.15829 13.3417 0.841709 13.1464 0.646447L12.3536 0.853553C12.1583 0.658291 11.8417 0.658291 11.6464 0.853553L5.25 7.25V8.75H6.75L13.1464 1.35355Z"
      fill="currentColor"
    />
  </svg>
);

export default EditIcon;
